module.exports = __webpack_public_path__ + "img/Graph_view_blue.b25b0da6.svg";